﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";

import OrderClassificationsTableHead from "./OrderClassificationsTableHead";
import OrderClassificationsTableBody from "./OrderClassificationsTableBody";
import OrderClassificationsForm from "./OrderClassificationsForm/OrderClassificationsForm";
import classes from "../maintainers.module.scss";

import { useOrderClassificationsPaginate, useMutateOrderClassification, useMutateDeleteOrderClassification } from "@/hooks/maintainers/order_classifications";
import { base_list } from "./order_classifications.constants";
import { hasPermission } from "@/services/Utils";

const OrderClassifications = () => {
	const { addToast } = useToasts();
	const { search } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useOrderClassificationsPaginate({
		...base,
		search,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateOrderClassification({
		...base,
		search,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteOrderClassification({
		...base,
		search,
	});

	const { orders_classification: list, customers, permissions } = data ? data : {};
	const { data: orders_classification, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast("Clasificación eliminada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, params: { ...data } },
			{
				onSuccess: () => {
					addToast("Clasificación guardada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Clasificaciones OC"
				button={true}
				button_text={"Nueva Clasificación"}
				action={() => navigate("/configuracion/clasificaciones_oc/crear")}
				back_url={"/configuracion?section=purchaseOrder"}
				isFetching={isFetching}
			/>

			{hasPermission("show", permissions) && (
				<Row className={` ${classes.main_row}`}>
					<Col md={12} className={classes.main_col}>
						<Row className={classes.table}>
							<div className={classes.table_div}>
								<Table className={classes.table_desktop}>
									<OrderClassificationsTableHead
										order={base.order}
										setOrder={setOrder}
										orderType={base.orderType}
										setOrderType={setOrderType}
									/>

									<OrderClassificationsTableBody
										orders_classification={orders_classification}
										handleDelete={handleDelete}
										permissions={permissions}
									/>
								</Table>
							</div>
						</Row>

						<BasePagination
							page={base.page}
							paginate={base.paginate}
							last_page={last_page}
							quantity={total}
							from={from}
							to={to}
							setPage={setPage}
							setPaginate={setPaginate}
						/>
					</Col>
				</Row>
			)}

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar clasificacion oc"}
			/>

			{option && <OrderClassificationsForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} customers={customers} permissions={permissions} />}
		</>
	);
};

export default OrderClassifications;
